import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IDialog } from 'src/models/dialog.model';
import { DialogAction } from "src/models/action-dialog.model";

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {
  // private command: number;
  actionName: string;
  actionId: string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDialog) { }

  ngOnInit() {
    // this.command = this.data.action;
    switch (this.data.action) {
      case DialogAction.create:
        this.actionId = "create";
        this.actionName = "등록";
        break;
      case DialogAction.read:
        this.actionId = "read";
        this.actionName = "조회";
        break;
      case DialogAction.update:
        this.actionId = "update";
        this.actionName = "수정";
        break;
      case DialogAction.delete:
        this.actionId = "delete";
        this.actionName = "삭제";
        break;
      default:
        this.actionName = ""
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
